import React from 'react';
import styeld from 'styled-components';

const ImgContainer = styeld.div`
  width: 90%;
  margin: 0 auto;
  img {
    width: 100%;
  }
`
const TextContainer = styeld.div`
  font-size: 1rem;
  font-weight: light;
  letter-spacing: 1px;
  width: 100%;
  text-align: center;
  padding: 15px 0;
`

const Complete = (props) => {
  const { image } = props.location.state;
  return (
    <div className="complete-container">
      <TextContainer>Long press image to Download</TextContainer>
      <ImgContainer>
        <img src={image} alt=""/>
      </ImgContainer>
    </div>
  );
};

export default Complete;